//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as LocationDropPinMediumSVG } from './assets/medium/location-drop-pin.inline.svg'

interface LocationDropPinMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const LocationDropPinMediumIcon: React.FC<
  React.PropsWithChildren<LocationDropPinMediumIconProps>
> = forwardRef<LocationDropPinMediumIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={LocationDropPinMediumSVG}
      sx={sx}
      color={color}
    />
  )
)
